// NovaAI.styles.web.ts
import {Platform, StyleSheet} from 'react-native';
import Typography from '../../../shared/constants/Typography';

export const createNovaAIWebStyles = (
  theme: any,
  width: number,
  height: number,
  isExpanded?: boolean,
) =>
  StyleSheet.create({
    floatingButton: {
      position: 'fixed' as any,
      bottom: 80,
      right: 36,
      // width: Typography.width.width72,
      // height: Typography.height.height72,
      // borderRadius: Typography.radius.radius36,
      // backgroundColor: theme.novaAIIconBGColor,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      zIndex: 9999,
      cursor: 'pointer' as any,
      // shadowColor: theme.dropdownShadowColor,
      // shadowOffset: {width: 0, height: Typography.height.height4},
      // shadowOpacity: 0.3,
      // shadowRadius: 8,
      // elevation: 10,
    },
    novaAIIcon: {
      width: Typography.width.width32,
      height: Typography.height.height32,
    },
    // Full-screen fixed overlay — transparent, does NOT block clicks outside chat window
    overlay: {
      position: 'fixed' as any,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'transparent',
      zIndex: 9998,
      pointerEvents: 'box-none' as any,
    },
    // Chat window wrapper — anchored bottom-right of the fixed overlay (= viewport).
    // When expanded: top is pinned below the nav header (80 px) so it never overlaps it.
    shadowWrapper: {
      position: Typography.position.absolute,
      ...(isExpanded
        ? {top: 80, bottom: 0, left: 0, right: 0}
        : {bottom: 80, right: 20, width: width, height: height}),
      shadowColor: theme.dropdownShadowColor,
    },
    modalView: {
      width: Typography.fullWidth,
      height: Typography.fullHeight,
      backgroundColor: theme.bGColor,
      borderRadius: Typography.radius.radius16,
      overflow: 'hidden',
      shadowColor: theme.dropdownShadowColor,
      shadowOffset: {width: 0, height: Typography.height.height4},
      shadowOpacity: 0.25,
      shadowRadius: 8,
      elevation: 8,
      borderWidth: 0.5,
      borderColor: theme.bGColor,
    },
  });
